import ButtonGroup from '../ButtonGroup';
import HorizontalRule from '../HorizontalRule';
import React, { Component, Fragment } from 'react';
import ReactHtmlParser from 'react-html-parser';
import './style.scss';
class PromoPanel extends Component {
  constructor(){
    super()
    this.state = {}
  }

  render(){
    // console.log(`PromoPanel.js\n$::`, this.props.data)
    const { data } = this.props
    let obj = {
      variant: data.lxl_promo_panel_variant || false,
      colorscheme: data.lxl_colorscheme || false,
      title: data.lxl_promo_panel_title || false,
      copy: data.lxl_promo_panel_copy || false,
      inlineImage: data.lxl_promo_panel_inline_image || false,
      backgroundImage: data.lxl_promo_panel_background_image || false,
      backgroundImageAlignment: data.lxl_promo_panel_background_image_alignment || false,
      buttons: data.lxl_button_group || false,
    }
    // console.log(`obj\n$::`, obj)
    const primaryPromoStyle = {
      backgroundImage: `url(${obj.backgroundImage.url})`
    }
    let classes = [`promo_panel-${obj.variant}`]
    classes = classes.join(' ')

    const href = window.location.href.split("/");
    let slug = href[href.length - 1];
    slug = slug ? slug : "more-than-height";
    if (slug === "ar") slug = "more-than-height";
    if (slug === "#content") slug = "more-than-height";
    if (process.env.REACT_APP_LANG === 'ar-ar' && slug === "more-than-height") { classes += ' promo_panel-ar'}
    return (
      <Fragment>
        <aside
          className={classes}
          data-colorscheme={obj.colorscheme}
          style={obj.variant === 'primary' ? primaryPromoStyle : {}}
        >
          <div className="content grid-columns-content">
            {obj.inlineImage && <img src={obj.inlineImage.url} alt={obj.inlineImage.alt} />}
            <div className="title">
              {obj.title}
              {obj.variant === 'primary' && <HorizontalRule data={{'lxl_separator_variant': 'hero'}} />}
            </div>
            {obj.copy && <div className="copy">{ReactHtmlParser(obj.copy)}</div>}
            {obj.buttons && <ButtonGroup data={obj.buttons}/>}
          </div>
          {obj.variant === 'tertiary' && obj.backgroundImage && <img src={obj.backgroundImage.url} alt="" role="presentation"/>}
          {obj.variant === 'secondary' && obj.backgroundImage && obj.backgroundImageAlignment && <img className={`image-${obj.backgroundImageAlignment}`} src={obj.backgroundImage.url} alt="" role="presentation"/>}
        </aside>
      </Fragment>
    )
  }
}

export default PromoPanel
